import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import "./Newhome.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

const BannerProgram = () => {
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };  
  return (
    <>
      {/* 🔷 TOP BANNER */}
      <div className="banner">
        <Grid container alignItems="center" className="banner-container">
          {/* LEFT */}
          <Grid size={{ xs: 12, md: 6 }} className="banner-left">
            <Typography className="banner-title">Swasth Bharat</Typography>

            <Typography className="banner-subtitle">
              Swasth Bharat One Platform. Every Patient. Healthier India
            </Typography>

            <Box className="banner-features">
              <div className="feature-item">
                  <img src="/images/NCDhome.svg" alt="Records" className="feature-icon" />
                <span>NCD</span>
              </div>

              <div className="feature-item">
                <img src="/images/JANANI.svg" alt="JANANI" className="feature-icon" />
                <span>JANANI</span>
              </div>

              <div className="feature-item">
               <img src="/images/Uwinhome.svg" alt="Records" className="feature-icon" />
                <span>U-WIN</span>
              </div>

              <div className="feature-item">
                <img src="/images/Nikshayhome.svg" alt="Records" className="feature-icon" />
                <span>ni-Kshay</span>
              </div>
               <div className="feature-item">
                <img src="/images/PMNDPhome.svg" alt="Records" className="feature-icon" />
                <span>PMNDP</span>
              </div>
               <div className="feature-item">
                <img src="/images/SATHhome.svg" alt="Records" className="feature-icon" />
                <span>SCD</span>
              </div>
            </Box>
          </Grid>

          {/* RIGHT */}
          <Grid size={{ xs: 12, md: 6 }} className="banner-right">
            <div className="image-card">
              <div className="newhomeslick">
                <Slider {...settings}>
                  <div>
                    <img
                      src="/images/Bannerfirst.svg"
                      className="banner-image"
                    />
                  </div>
                  <div>
                    <img
                      src="/images/Baneersecond.svg"
                      className="banner-image"
                    />
                  </div>
                  <div>
                    <img
                      src="/images/Baneerthired.svg"
                      className="banner-image"
                    />
                  </div>
                  <div>
                    <img
                      src="/images/Bannerfour.svg"
                      className="banner-image"
                    />
                  </div>
                </Slider>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default BannerProgram;
